import { render, staticRenderFns } from "./AssessmentRangeSection.vue?vue&type=template&id=f2db9dc4&scoped=true"
import script from "./AssessmentRangeSection.vue?vue&type=script&lang=js"
export * from "./AssessmentRangeSection.vue?vue&type=script&lang=js"
import style0 from "./AssessmentRangeSection.vue?vue&type=style&index=0&id=f2db9dc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2db9dc4",
  null
  
)

export default component.exports